export default __webpack_public_path__ + "static/Alex_Derner_BW_WEB-c6aaa70147cfa7c5a3c5d70c2dfff328.jpg";